"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CarvanaThemeProps = exports.CarvanaTheme = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _Typography = _interopRequireDefault(require("../Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarvanaTheme = {
  carvana: {
    body: '#e4ecf0',
    blue: {
      primary: '#00aed9',
      hover: '#018dc0',
      medium: '#00619e',
      dark: '#183558',
      pastel: '#cfeaf2'
    },
    gray: {
      background: '#f4f8fa',
      light: '#d9dde9',
      medium: '#aab1c7',
      dark: '#757989'
    },
    green: {
      primary: '#1dd08b'
    },
    red: {
      primary: '#ff7171'
    },
    yellow: {
      primary: '#feb948',
      hover: '#eb9f23',
      pastel: '#fbf2de'
    },
    white: {
      primary: '#ffffff'
    },
    stroke: {
      blue: '#122946'
    },
    impersonationRed: '#ff0000'
  },
  typography: _Typography.default,
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1280,
      xl: 1920
    }
  }
};
exports.CarvanaTheme = CarvanaTheme;
var CarvanaThemeProps = {
  theme: _propTypes.default.shape({
    carvana: _propTypes.default.shape({
      body: _propTypes.default.string,
      blue: _propTypes.default.shape({
        primary: _propTypes.default.string,
        hover: _propTypes.default.string,
        medium: _propTypes.default.string,
        dark: _propTypes.default.string,
        pastel: _propTypes.default.string
      }),
      gray: _propTypes.default.shape({
        background: _propTypes.default.string,
        light: _propTypes.default.string,
        medium: _propTypes.default.string,
        dark: _propTypes.default.string
      }),
      green: _propTypes.default.shape({
        primary: _propTypes.default.string
      }),
      red: _propTypes.default.shape({
        primary: _propTypes.default.string
      }),
      yellow: _propTypes.default.shape({
        primary: _propTypes.default.string,
        hover: _propTypes.default.string,
        pastel: _propTypes.default.string
      }),
      white: _propTypes.default.shape({
        primary: _propTypes.default.string
      }),
      stroke: _propTypes.default.shape({
        blue: _propTypes.default.string
      }),
      impersonationRed: _propTypes.default.string
    })
  }),
  typography: _propTypes.default.shape({}),
  breakpoints: _propTypes.default.shape({})
};
exports.CarvanaThemeProps = CarvanaThemeProps;
CarvanaTheme.propTypes = CarvanaThemeProps;

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return _react.default.createElement(_styledComponents.ThemeProvider, {
    theme: theme,
    "data-qa": "theme-provider"
  }, children);
};

ThemeProvider.defaultProps = {
  theme: CarvanaTheme
};
var _default = ThemeProvider;
exports.default = _default;